import { Keys } from './en';

const translations: Record<Keys, string> = {
  'By connecting a wallet, you agree to <1>Paradex Terms of Service</1> and represent and warrant to Paradex that you are not a <2>Restricted Person</2>.':
    'Bằng cách kết nối ví, bạn đồng ý với <1>Điều Khoản Dịch Vụ của Paradex</1> và đại diện và bảo đảm cho Paradex rằng bạn không phải là một <2>Người bị hạn chế</2>.',
  Positions: 'Vị trí',
  'Open Orders': 'Đơn hàng đang mở',
  'Trade History': 'Lịch sử giao dịch',
  'Order History': 'Lịch sử đơn hàng',
  'Funding Payments': 'Thanh toán tài trợ',
  Portfolio: 'Danh mục đầu tư',
  Trade: 'Buôn bán',
  Developers: 'Nhà phát triển',
  Docs: 'Tài liệu',
  'API Docs': 'Tài liệu API',
  'Code Samples': 'Mẫu mã',
  More: 'Thêm',
  Stats: 'Thống kê',
  'Join Discord': 'Tham gia Discord',
  Notifications: 'Thông báo',
  'All caught up!': 'Đã cập nhật tất cả!',
  'You have no new notifications': 'Bạn không có thông báo mới',
  'Display Toast Notifications': 'Hiển thị thông báo Toast',
  'Connect Wallet': 'Kết nối ví',
  'Connect your Wallet': 'Kết nối ví của bạn',
  'Choose Wallet': 'Chọn ví',
  'Link Wallet': 'Liên kết ví',
  'You will receive a signature request. Signing is free and will not send a transaction.':
    'Bạn sẽ nhận được yêu cầu ký. Việc ký miễn phí và sẽ không gửi giao dịch.',
  'Generate Private Key': 'Tạo khóa riêng',
  'Generating Private Key': 'Đang tạo khóa riêng',
  'Private Key Generated': 'Đã tạo khóa riêng',
  'Enable secure access to our API':
    'Kích hoạt truy cập an toàn đến API của chúng tôi',
  'Remember Me': 'Nhớ tôi',
  'Only use “Remember Me” if you are using a secure device you own. Selecting this option can expose your information to  others if you are accessing this wallet from a public device.':
    'Chỉ sử dụng “Nhớ tôi” nếu bạn đang sử dụng thiết bị an toàn của riêng bạn. Chọn tùy chọn này có thể tiết lộ thông tin của bạn cho người khác nếu bạn đang truy cập ví này từ thiết bị công cộng.',
  Continue: 'Tiếp tục',
  'Disconnect Wallet': 'Ngắt kết nối ví',
  Disconnect: 'Ngắt kết nối',
  Account: 'Tài khoản',
  Username: 'Tên người dùng',
  Edit: 'Chỉnh sửa',
  'Your username is now hidden. It is not visible to other users.':
    'Tên người dùng của bạn hiện đã bị ẩn. Nó không hiển thị cho người dùng khác.',
  'Edit Your Username': 'Chỉnh sửa tên người dùng của bạn',
  'Your username will be visible to other users unless you choose to hide it. You can always change it later.':
    'Tên người dùng của bạn sẽ hiển thị cho người dùng khác trừ khi bạn chọn ẩn nó. Bạn luôn có thể thay đổi nó sau.',
  'Hide my Username': 'Ẩn tên người dùng của tôi',
  Save: 'Lưu',
  'Username is required': 'Yêu cầu tên người dùng',
  'Username must be between 5 and 20 characters':
    'Tên người dùng phải từ 5 đến 20 ký tự',
  'Username can only contain letters and numbers':
    'Tên người dùng chỉ có thể chứa chữ cái và số',
  Wallets: 'Ví',
  'L1 Address': 'Địa chỉ L1',
  'L2 Address': 'Địa chỉ L2',
  'Open in Explorer': 'Mở trong trình duyệt',
  'Sign Out': 'Đăng xuất',
  'Copy L2 Private Key': 'Sao chép khóa riêng L2',
  'No markets available': 'Không có thị trường nào',
  Market: 'Thị trường',
  'Last Price': 'Giá cuối cùng',
  'Open Interest': 'Lượng mở',
  '24h Volume': 'Khối lượng 24h',
  'Mark Price': 'Giá đánh dấu',
  'Spot Oracle Price': 'Giá Oracle Spot',
  'Eight hour funding rate that is continuously accrued on positions and settled upon any trade':
    'Tỷ lệ tài trợ 8 giờ liên tục được tích lũy trên các vị trí và được thanh toán khi giao dịch',
  '8h Funding Rate': 'Tỷ lệ tài trợ 8 giờ',
  Limit: 'Giới hạn',
  LIMIT: 'GIỚI HẠN',
  MARKET: 'THỊ TRƯỜNG',
  'Limit Price': 'Giá giới hạn',
  Amount: 'Số lượng',
  'Your order stays open until it is filled or you decide to cancel.':
    'Đơn đặt hàng của bạn vẫn mở cho đến khi nó được điền hoặc bạn quyết định hủy.',
  'Your order gets filled right away, partially or fully, and whatever is left gets canceled instantly.':
    'Đơn đặt hàng của bạn được điền ngay lập tức, một phần hoặc toàn bộ, và bất cứ thứ gì còn lại sẽ bị hủy ngay lập tức.',
  Fee: 'Phí',
  'Currently the fees are fixed and uniform across the platform. Maker {{makerFee}} / Taker {{takerFee}}':
    'Hiện tại, phí được cố định và đồng nhất trên toàn nền tảng. Maker {{makerFee}} / Taker {{takerFee}}',
  Notional: 'Định danh',
  Buy: 'Mua',
  BUY: 'MUA',
  Sell: 'Bán',
  SELL: 'BÁN',
  'Account Value': 'Giá trị tài khoản',
  'The total value of your account at current mark prices':
    'Tổng giá trị tài khoản của bạn tại giá đánh dấu hiện tại',
  'Unrealized P&L': 'P&L chưa thực hiện',
  'Free Collateral': 'Đảm bảo tự do',
  'Account Leverage': 'Tài khoản đòn bẩy',
  Margin: 'Lề',
  'Initial Margin': 'Lề ban đầu',
  'Maintenance Margin': 'Lề bảo dưỡng',
  'Account value / maintenance margin requirements':
    'Giá trị tài khoản / yêu cầu lề bảo dưỡng',
  'Health Factor': 'Yếu tố sức khỏe',
  'Order Book': 'Sách đặt hàng',
  Trades: 'Giao dịch',
  Price: 'Giá',
  Size: 'Kích thước',
  Total: 'Tổng',
  Time: 'Thời gian',
  Spread: 'Chênh lệch',
  Side: 'Bên',
  'Entry Price': 'Giá vào',
  'Unrealized Funding': 'Quỹ chưa thực hiện',
  'Close Position': 'Đóng vị trí',
  Type: 'Loại',
  Filled: 'Đã điền',
  Instruction: 'Hướng dẫn',
  'Client Order Id': 'Id đơn hàng của khách hàng',
  Status: 'Trạng thái',
  'Notional / Fee': 'Định danh / Phí',
  Liquidity: 'Thanh khoản',
  'Tx Hash': 'Hash giao dịch',
  Id: 'Id',
  Remaining: 'Còn lại',
  'Cancel Reason': 'Lý do hủy bỏ',
  'Order Id': 'Id đơn hàng',
  Payment: 'Thanh toán',
  'Cancel All': 'Hủy tất cả',
  '{{orderSize}} will be closed at Market price':
    '{{orderSize}} sẽ được đóng với giá thị trường',
  Wallet: 'Ví',
  Deposit: 'Tiền gửi',
  Withdraw: 'Rút',
  Withdrawal: 'Rút tiền',
  'Collateral Value': 'Giá trị tài sản thế chấp',
  'Position Notional': 'Định danh vị trí',
  Collateral: 'Tài sản thế chấp',
  Asset: 'Tài sản',
  'Wallet Balance': 'Số dư ví',
  Actions: 'Hành động',
  Action: 'Hành động',
  'Tx Hash L2': 'Hash giao dịch L2',
  'Tx Hash L1': 'Hash giao dịch L1',
  'Withdraw to Wallet': 'Rút về ví',
  'Deposit to Paraclear': 'Gửi tiền vào Paraclear',
  'You have no balance in your Ethereum wallet. Deposit some {{asset}} and try again.':
    'Bạn không có số dư trong ví Ethereum của mình. Gửi một số {{asset}} và thử lại.',
  'It is not possible to deposit more than your current balance.':
    'Không thể gửi nhiều hơn số dư hiện tại của bạn.',
  'Available on L1': 'Có sẵn trên L1',
  'Deposits are a two-step process. First initiate a deposit from your Ethereum wallet':
    'Việc gửi tiền là một quy trình hai bước. Đầu tiên, khởi tạo một khoản tiền gửi từ ví Ethereum của bạn',
  'Deposits are a two-step process. First initiate a deposit from your Ethereum wallet to the Starknet bridge. Second, initiate deposit from the Starknet bridge to Paraclear via the Deposit / Withdraw table. These transactions may take several minutes depending on network conditions. For more information check out our <1>docs</1>.':
    'Việc gửi tiền là một quy trình hai bước. Đầu tiên, khởi tạo một khoản tiền gửi từ ví Ethereum của bạn đến cầu Starknet. Thứ hai, khởi tạo khoản tiền gửi từ cầu Starknet đến Paraclear qua bảng Gửi / Rút tiền. Những giao dịch này có thể mất vài phút tùy thuộc vào điều kiện mạng. Để biết thêm thông tin, hãy xem <1>tài liệu của chúng tôi</1>.',
  'read more': 'đọc thêm',
  'Initiate Deposit to Bridge': 'Khởi tạo gửi tiền đến cầu',
  'Enable USDC on Paradex': 'Kích hoạt USDC trên Paradex',
  'In order to deposit you must allow Paradex access to at least {{amount}}.':
    'Để gửi tiền, bạn phải cho phép Paradex truy cập ít nhất {{amount}}.',
  'Enable USDC': 'Kích hoạt USDC',
  'Withdraw initiated': 'Đã khởi tạo rút tiền',
  'Withdrawals are a two-step process. First initiate a withdrawal from Paraclear':
    'Việc rút tiền là một quy trình hai bước. Đầu tiên, khởi tạo rút tiền từ Paraclear',
  'Withdrawals are a two-step process. First initiate a withdrawal from Paraclear to the Starknet bridge. This first step can take 2-7 hours. Second, initiate your withdrawal from the Starknet bridge to your Ethereum wallet via the Deposit / Withdraw table. For more information check out our <1>docs</1>.':
    'Việc rút tiền là một quy trình hai bước. Đầu tiên, khởi tạo rút tiền từ Paraclear đến cầu Starknet. Bước đầu tiên này có thể mất từ 2-7 giờ. Thứ hai, khởi tạo rút tiền của bạn từ cầu Starknet đến ví Ethereum của bạn qua bảng Gửi / Rút tiền. Để biết thêm thông tin, hãy xem <1>tài liệu của chúng tôi</1>.',
  'Initiate Withdrawal to Bridge': 'Khởi tạo rút tiền đến cầu',
  'You have no funds to withdraw. It is not possible to withdraw more than your free collateral.':
    'Bạn không có tiền để rút. Không thể rút nhiều hơn tài sản thế chấp tự do của bạn.',
  'It is not possible to withdraw more than your free collateral.':
    'Không thể rút nhiều hơn tài sản thế chấp tự do của bạn.',
  'You have no collateral': 'Bạn không có tài sản thế chấp',
  'You have no open positions': 'Bạn không có vị trí mở',
  'You have no open orders': 'Bạn không có đơn hàng mở',
  'You have no trades': 'Bạn không có giao dịch nào',
  'You have no orders': 'Bạn không có đơn hàng nào',
  'You have no funding payments': 'Bạn không có khoản thanh toán nào',
  'You have no transfers': 'Bạn không có chuyển khoản nào',
  'Account in liquidation': 'Tài khoản đang trong quá trình thanh lý',
  'Account is being liquidated. Any open positions will be closed. Trading now is disabled.':
    'Tài khoản đang được thanh lý. Bất kỳ vị trí mở nào cũng sẽ được đóng. Giao dịch hiện đã bị vô hiệu hóa.',
  'Account liquidated': 'Tài khoản đã được thanh lý',
  'Your account was liquidated on {{createdAt}}. Any open positions were closed.':
    'Tài khoản của bạn đã được thanh lý vào {{createdAt}}. Bất kỳ vị trí mở nào cũng đã được đóng.',
  'Deposit to Paraclear successful': 'Gửi tiền vào Paraclear thành công',
  'Deposit to Paraclear failed': 'Gửi tiền vào Paraclear thất bại',
  'Unexpected error. Try again.': 'Lỗi không mong đợi. Hãy thử lại.',
  'Deposit to bridge initiated': 'Bắt đầu gửi tiền vào cầu',
  'Deposit to Paraclear available': 'Có thể gửi tiền vào Paraclear',
  'Go to Deposits': 'Đi đến Tiền gửi',
  'Deposit to Paraclear in progress': 'Đang gửi tiền vào Paraclear',
  '<1>Paradex Closed Beta</1> This is a CLOSED BETA version of Paradex, the product is still being tested and can be subject to bugs and errors. For more details please read carefully the <2>Paradex terms of service</2> & <3>documentation</3>.':
    '<1>Paradex Closed Beta</1> Đây là phiên bản BETA ĐÓNG của Paradex, sản phẩm vẫn đang được thử nghiệm và có thể chịu ảnh hưởng của lỗi và sai sót. Để biết thêm chi tiết, vui lòng đọc kỹ <2>điều khoản dịch vụ Paradex</2> & <3>tài liệu</3>.',
  'Limit {{side}} Order Fill': 'Điền đơn hàng giới hạn {{side}}',
  '{{type}} {{side}} Order Submitted': 'Đơn hàng {{type}} {{side}} đã được gửi',
  '{{type}} {{side}} Order Canceled': 'Đơn hàng {{type}} {{side}} đã bị hủy',
  Reason: 'Lý do',
  'Market {{side}} Order Fill': 'Điền đơn hàng thị trường {{side}}',
  'Trade Busted On-Chain': 'Giao dịch bị hủy trên chuỗi',
  'Fill id': 'Điền id',
  'Withdraw to wallet failed': 'Rút tiền vào ví thất bại',
  'Withdrawal to bridge initiated': 'Bắt đầu rút tiền vào cầu',
  'Withdrawal error. Try again.': 'Lỗi rút tiền. Hãy thử lại.',
  'Withdrawal to bridge in progress': 'Đang rút tiền vào cầu',
  'Withdrawal to wallet initiated': 'Bắt đầu rút tiền vào ví',
  'Withdrawal to bridge failed': 'Rút tiền vào cầu thất bại',
  'Transaction error. Try again.': 'Lỗi giao dịch. Hãy thử lại.',
  'Withdrawal to wallet available': 'Có thể rút tiền vào ví',
  'Go to Withdrawals': 'Đi đến Rút tiền',
  'Withdrawal to wallet successful': 'Rút tiền vào ví thành công',
  'Session expired, please connect your wallet again.':
    'Phiên đã hết hạn, vui lòng kết nối lại ví của bạn.',
  'Failed to submit order': 'Không thể gửi đơn hàng',
  'Your username preferences were updated!':
    'Tùy chọn tên người dùng của bạn đã được cập nhật!',
  'Unexpected error updating username preferences':
    'Lỗi không mong đợi khi cập nhật tùy chọn tên người dùng',
  'This username already exists. Please choose a different username and try again.':
    'Tên người dùng này đã tồn tại. Vui lòng chọn một tên người dùng khác và thử lại.',
};

export default translations;
